// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const hu: KnowledgePagesCopy = {
  knowledgePage: 'Tudásoldal',
  knowledgePages: 'Tudásoldalak',
  featureOffTitle: 'A tudásoldalak nincsenek engedélyezve ebben a munkaterületben.',
  featureOffBody: 'A céges kontextus és a források továbbra is a Tudás részben találhatók.',
  loadingPage: 'Oldal betöltése…',
  loadingSuggestion: 'Javaslat betöltése…',
  cancel: 'Mégse',
  tryAgain: 'Újrapróbálás',
  everyoneIn: '{company} minden tagja',
  yourCompany: 'az Ön cége',
  revision: '{n}. változat',
  openRevision: '{n}. változat megnyitása',
  pageCount: 'one:oldal|other:oldal',
  topicCount: 'one:témakör|other:témakör',
  sectionCount: 'one:szakasz|other:szakasz',
  lineCount: 'one:sor|other:sor',
  documentCount: 'one:dokumentum|other:dokumentum',
  changeCount: 'one:módosítás|other:módosítás',
  newPageCount: 'one:új oldal|other:új oldal',
  changedPageCount: 'one:módosult oldal|other:módosult oldal',
  otherSectionCount: 'one:további szakasz|other:további szakasz',
  characterCount: 'one:karakter|other:karakter',
  diffStats: '{sections} módosult · {added} hozzáadva · {removed} eltávolítva',
  diffMatchesBase: 'A javasolt szöveg megegyezik az alapváltozattal.',
  diffIntroduction: 'Bevezetés',
  diffOtherUnchanged: '{sections} változatlan.',
  timeJustNow: 'épp most',
  originImportedFrom: 'Importálva innen: {path}',
  originImportedFromCommit: 'Importálva innen: {path} @ {commit}',
  authorityApprovedInPoneva: 'Jóváhagyva a Poneva felületén',
  authorityImported: 'Importálva',
  authorityInRepository: '{canonicality} a tárolóban',
  authorityVerified: 'ellenőrizve: {date}',
  authorRepositoryImport: 'Importálás tárolóból',
  authorSuggestedInChat: 'Csevegésben javasolva',
  authorSuggestedInChatWith: 'Csevegésben javasolva ({name})',
  authorSuggestedBy: 'Javasolta: {name}',
  authorSuggestedByApp: 'Egy csatlakoztatott alkalmazás javasolta',
  authorSuggestedByColleague: 'Egy kolléga javasolta',
  authorSuggestedByYou: 'Ön javasolta',
  authorSuggestedOnBehalf: 'Javasolta: {app}, {name} nevében',
  authorSuggestedByAppOnBehalf: 'Egy csatlakoztatott alkalmazás javasolta {name} nevében',
  authorSuggestedAndApproved: 'Javasolta és jóváhagyta: {name}',
  approverApprovedBy: 'jóváhagyta: {name}',
  approverAppliedBy: 'alkalmazta: {name}',
  kindCreatePage: 'Új oldal',
  kindUpdatePage: 'Javasolt frissítés',
  kindArchivePage: 'Archiválás',
  statusConflict: 'Ütközés · az oldal megváltozott',
  statusPending: 'Ellenőrzésre vár',
  statusApproved: 'Jóváhagyva',
  statusRejected: 'Elvetve',
  statusWithdrawn: 'Visszavonva',
  statusSuperseded: 'Elavult',
  errRevisionConflict: 'Ez az oldal megváltozott, miközben Ön ellenőrizte.',
  errProposalChanged:
    'Ez a javaslat megváltozott, miközben Ön ellenőrizte. Döntés előtt nézze át a legújabb verziót.',
  errPublishRequired:
    'Csak a cég közzétevői hagyhatnak jóvá tudásmódosításokat vagy importálhatnak oldalakat.',
  errProposalLimit:
    'A cégénél már 200 javaslat vár ellenőrzésre. Újabb javaslatok előtt nézzen át közülük néhányat.',
  errAuthorLimit:
    'Már 50 javaslata vár ellenőrzésre. Újabb javaslatok előtt várja meg, amíg némelyikről döntenek, vagy vonjon vissza néhányat.',
  errImportProposalLimit:
    'Ez az importálás több módosult oldalt küldene ellenőrzésre, mint amennyi a cége ellenőrzési sorába belefér (legfeljebb 200). Döntsön néhány javaslatról az Ellenőrzésre vár lapon, majd alkalmazza újra.',
  errImportChanged:
    'Ez nem az az importálás, amelyet Ön átnézett. Nyissa meg újra, és alkalmazás előtt nézze át.',
  errImportItemNotFound: 'Ez a dokumentum már nem része az importálásnak.',
  errIdempotencyConflict:
    'Ezt a javaslatot már elküldték más tartalommal. Töltse be újra, és próbálja újra.',
  errImportHashMismatch:
    'A pillanatkép egyik fájlja nem egyezik a rögzített ellenőrzőösszegével. Készítse el újra a pillanatképet, és próbálja újra.',
  errImportAlreadyApplied: 'Ezt az importálást már alkalmazták.',
  errImportDiscarded: 'Ezt az importálást elvetették. Válassza ki újra a pillanatképfájlt.',
  errImportDuplicateItem:
    'Ez a pillanatkép kétszer tartalmazza ugyanazt a dokumentumot. Készítse el újra a pillanatképet.',
  errInvalidImport:
    'A Poneva nem tudta elfogadni ezt a pillanatképet. Készítse el újra a pillanatkép-szkripttel, és próbálja újra.',
  errInvalidInput:
    'A Poneva nem tudta elfogadni ezt a bevitelt. Ellenőrizze a mezőket, és próbálja újra.',
  errImportLimit:
    'Túl sok importálás van előkészítve, de nincs alkalmazva. Alkalmazzon vagy vessen el néhányat, mielőtt újat készít elő.',
  errPageTooLarge: 'Egy oldal nagyobb 256 KB-nál. Ossza fel kisebb oldalakra.',
  errTooManySections: 'Egy oldalon több mint 2000 címsor van. Ossza fel kisebb oldalakra.',
  errPageLimit: 'A cége elérte a 2000 tudásoldalas korlátot.',
  errCollectionLimit: 'A cége elérte a 100 témakörös korlátot.',
  errProposalNotPending: 'Erről a javaslatról már döntöttek. A megjelenített állapot az aktuális.',
  errRequesterRemoved:
    'A javaslatot tevő személy már nem tagja ennek a cégnek, ezért a javaslat nem hagyható jóvá.',
  errRevisionAlreadyCurrent: 'Ez a változat már az aktuális.',
  errPageArchived:
    'Ezt az oldalt archiválták, miközben Ön ellenőrizte. Döntés előtt nézze át újra a javaslatot.',
  errAlreadyArchived: 'Ez az oldal már archiválva van.',
  errProposalForbidden: 'Csak a javaslatot tevő személy vonhatja vissza.',
  errUnavailable: 'A tudásoldalak jelenleg nem érhetők el.',
  errTimeout: 'A Poneva túl sokáig nem válaszolt.',
  errItemTooLarge: 'A(z) {path} nagyobb 256 KB-nál. Ossza fel kisebb oldalakra.',
  errItemTooManySections:
    'A(z) {path} több mint 2000 címsort tartalmaz. Ossza fel kisebb oldalakra.',
  errItemHashMismatch:
    'A(z) {path} nem egyezik a rögzített ellenőrzőösszegével. Készítse el újra a pillanatképet, és próbálja újra.',
  errNoLongerAvailable: 'Ez az elem már nem érhető el az Ön számára.',
  errTooLargeToSend: 'Ez a fájl túl nagy a küldéshez.',
  cardChecking: 'Állapot ellenőrzése…',
  cardNotAvailable: 'Nem érhető el',
  cardStatusUnavailable: 'Az állapot nem érhető el',
  cardUnshowable: 'Ezt a javasolt tudásfrissítést nem sikerült megjeleníteni.',
  cardEyebrow: 'Javasolt tudásfrissítés',
  cardLabel: 'Javasolt tudásfrissítés · {title}',
  cardMissing: 'Ez a javaslat már nem érhető el az Ön számára.',
  cardUnknown:
    'Nem sikerült ellenőrizni, hol tart ez a javaslat. Az állapotáért nyissa meg az ellenőrzést.',
  cardCheckAgain: 'Újraellenőrzés',
  cardReview: 'Frissítés ellenőrzése',
  statusLineApproved: 'Jóváhagyott ismeretek',
  readyCount: 'one:kereshető|other:kereshető',
  preparingCount: 'one:előkészítés alatt|other:előkészítés alatt',
  attentionCount: 'one:beavatkozást igényel|other:beavatkozást igényel',
  topicsExplore: 'Témakör felfedezése',
  topicsAllPages: 'Összes oldal',
  topicsOpenPages: 'Oldalak megnyitása',
  topicsEmpty:
    'Még nincsenek jóváhagyott oldalak. Az oldalak a cég részletes ismereteit tárolják, teljes változattörténettel.',
  reviewsTitle: 'Javasolt oldalfrissítések',
  reviewsTitleMine: 'Az Ön javasolt oldalfrissítései',
  reviewsIntro:
    'Minden javaslat egy teljes változatjelölt indoklással és bizonyítékokkal. Semmi sem változik, amíg pontosan azt a változatot jóvá nem hagyja.',
  reviewsIntroMine:
    'A javaslatai itt várnak, amíg a cég egyik közzétevője át nem nézi őket. Addig az oldalak változatlanok maradnak.',
  loadPagesFailed: 'Nem sikerült betölteni a tudásoldalakat.',
  loadProposalsFailed: 'Nem sikerült betölteni a javasolt oldalfrissítéseket.',
  loadMoreFailed: 'Nem sikerült további oldalakat betölteni.',
  otherPages: 'Egyéb oldalak',
  loadTopicFailed: 'Nem sikerült betölteni ezt a témakört.',
  revisionShort: 'v{n}',
  updatedOn: 'Frissítve: {date}',
  emptyTitle: 'Még nincsenek tudásoldalak.',
  emptyBody:
    'Az oldalak a cége jóváhagyott, részletes ismereteit tárolják – irányokat, döntéseket és munkamódszereket –, minden változat megőrzésével. Importáljon tárolópillanatképből, vagy kezdjen egy oldalt a csevegésben; minden oldalt egy közzétevő hagy jóvá, mielőtt céges tudásnak számítana.',
  importFromSnapshot: 'Importálás tárolópillanatképből',
  startInChat: 'Oldal indítása a csevegésben',
  startInChatPrompt:
    'Segíts elindítani egy tudásoldalt a cégünk számára. Kérdezd meg, mit tartalmazzon, és ne találj ki tartalmat. Javaslat marad, amíg a cég egyik közzétevője jóvá nem hagyja.',
  loadingPages: 'Tudásoldalak betöltése…',
  filterLabel: 'Oldalak szűrése cím szerint',
  filterPlaceholder: 'Oldalak szűrése',
  importButton: 'Importálás',
  showingTopic: 'Megjelenítve: {topic}',
  showAllTopics: 'Összes témakör megjelenítése',
  loadingTopic: 'Témakör betöltése…',
  noMatch: 'Egy oldal sem felel meg ennek: „{filter}”.',
  topicNoPages: 'Ebben a témakörben még nincsenek jóváhagyott oldalak.',
  loading: 'Betöltés…',
  loadMore: 'További oldalak betöltése',
  metaApproved: 'jóváhagyva: {date}',
  metaRepositoryAuthoritative: 'a tároló marad a mérvadó',
  loadPageFailed: 'Nem sikerült betölteni ezt az oldalt.',
  loadHistoryFailed: 'Nem sikerült betölteni a változattörténetet.',
  outlineLabel: 'Az oldal szakaszai',
  outlineToggle: 'Ezen az oldalon',
  loadingHistory: 'Változattörténet betöltése…',
  historyLabel: 'Változattörténet',
  historyIntro:
    'Minden jóváhagyott változat megmarad. Egy korábbi változat visszaállítása ellenőrzendő javaslatot hoz létre; a későbbi változatokat soha nem törli.',
  historyCurrent: 'Aktuális',
  historyViewing: 'Megtekintve',
  historyView: 'Megtekintés',
  historyViewAria: '{n}. változat megtekintése',
  restoreAria: 'Visszaállítás javaslatként: {n}. változat',
  restoreCreating: 'Javaslat létrehozása…',
  restore: 'Visszaállítás javaslatként',
  restoreUnconfirmed:
    'Nem sikerült megerősíteni, hogy a javaslat létrejött. Újrapróbálás előtt ellenőrizze az Ellenőrzésre vár lapot.',
  editTooLarge: 'Ez az oldal nagyobb 256 KB-nál. Mielőtt javasolná, ossza fel kisebb oldalakra.',
  editConflict:
    'Ez az oldal megváltozott, miközben Ön szerkesztette. Másolja ki a szövegét, nyissa meg a legújabb változatot, és javasolja újra a módosítást.',
  editUnconfirmed:
    'Nem sikerült megerősíteni, hogy a javaslata elküldésre került. Újraküldés előtt ellenőrizze az Ellenőrzésre vár lapot.',
  editHeading: 'Módosítás javaslása',
  editIntro:
    'Ön a(z) {n}. változatot szerkeszti. A cég egyik közzétevője pontosan ezt a módosítást ellenőrzi, mielőtt a(z) {next}. változattá válik; addig az oldal változatlan marad.',
  editOutdated:
    'Szerkesztés közben jóváhagytak egy újabb változatot. Másolja ki a szövegét, majd kezdje újra a legújabb változatból, hogy az abban végzett módosítások ne vesszenek el.',
  editContentLabel: 'Az oldal tartalma (Markdown)',
  editReasonLabel: 'Miért ez a módosítás?',
  editReasonPlaceholder: 'Mi változott, és honnan származik.',
  editSending: 'Küldés…',
  editSend: 'Küldés ellenőrzésre',
  editDiscardConfirm: 'Elveti ezt a módosítást? Semmit sem küldtünk el abból, amit módosított.',
  editNoChanges: 'Még nincs módosítás.',
  editNeedsContent: 'Az oldalnak tartalomra van szüksége.',
  exportFailed: 'Nem sikerült exportálni ezt az oldalt. Próbálja újra.',
  askPagePrompt: 'Kérdés a(z) „{title}” tudásoldalról ({n}. változat, {link}):',
  askPageSectionPrompt: 'Kérdés a(z) „{title}” tudásoldalról, § {section} ({n}. változat, {link}):',
  pageMissingTitle: 'Ez az oldal nem érhető el.',
  pageMissingBody: 'Lehet, hogy archiválták, vagy Ön már nem fér hozzá ennek a cégnek a tudásához.',
  pageArchived: 'Archiválva',
  viewingRevisionCurrent: 'Ön a(z) {n}. változatot nézi; az aktuális változat: {current}.',
  viewingRevisionOld: 'Ön a(z) {n}. változatot nézi. Ez nem az aktuális változat.',
  openCurrent: 'Aktuális megnyitása',
  archivedBanner:
    'Ez az oldal archiválva van. Már nem befolyásolja a válaszokat; az előzményei megmaradnak.',
  pageViewsLabel: 'Oldalnézetek',
  tabRead: 'Olvasás',
  tabHistory: 'Előzmények',
  unknownSection: 'A hivatkozott szakasz nem része ennek a változatnak. A teljes oldal látható.',
  askAboutPage: 'Kérdés erről az oldalról',
  exporting: 'Exportálás…',
  exportMarkdown: 'Exportálás Markdownként',
  loadSuggestionFailed: 'Nem sikerült betölteni ezt a javaslatot.',
  evidenceSource: 'Forrás',
  evidenceFact: 'Céges kontextus',
  evidenceResult: 'Mentett munka',
  evidenceUrl: 'Weboldal',
  evidenceDecision: 'Döntés',
  evidenceReference: 'Hivatkozás',
  evidenceOpenPage: 'Tudásoldal megnyitása',
  evidenceOpenSource: 'Forrás megnyitása',
  evidenceOpenFact: 'Céges kontextus megnyitása',
  evidenceOpenResult: 'Mentett munka megnyitása',
  evidenceOpenUrl: 'Weboldal megnyitása',
  evidenceOpenDecision: 'Döntés megnyitása',
  evidenceOpenReference: 'Hivatkozás megnyitása',
  evidenceDecisionNote: 'Rögzített döntés. A Poneva felületén nincs mit megnyitni.',
  evidenceFactGone: 'Ez a céges kontextus már nincs mentve.',
  evidencePageNoRevision: 'Ennek az oldalnak nincs megnyitható jóváhagyott változata.',
  evidencePrivateExcerpt: 'Privát bizonyíték – csak a fenti részletet osztották meg.',
  evidencePrivate: 'Privát bizonyíték – a tartalmát nem osztották meg Önnel.',
  evidenceHeading: 'Bizonyítékok',
  evidenceNone: 'Nincs csatolt bizonyíték. A fenti indoklást önmagában mérlegelje.',
  changeAdded: 'Hozzáadva',
  changeRemoved: 'Eltávolítva',
  changeChanged: 'Módosítva',
  changeUnchanged: 'Változatlan',
  moreLineCount: 'one:további sor|other:további sor',
  moreUnchangedLineCount: 'one:további változatlan sor|other:további változatlan sor',
  unchangedLineCount: 'one:változatlan sor|other:változatlan sor',
  skipAdded: '{lines} – a teljes változatban látható',
  skipRemoved: '{lines} eltávolítva',
  cutUnchanged: '{lines} nem látható',
  cutChanged: '{lines} nem látható, {changes}. Ellenőrizze őket a teljes változatban.',
  cutAddedRemoved: '{added} hozzáadva és {removed} eltávolítva',
  cutAdded: '{added} hozzáadva',
  cutRemoved: '{removed} eltávolítva',
  lineAddedSr: 'Hozzáadva:',
  lineRemovedSr: 'Eltávolítva:',
  noLinesAdded: 'Új szakasz. A szövege az alábbi teljes változatban található.',
  noLinesRemoved: 'Ez a szakasz kikerülne az oldalról.',
  noLinesChanged: 'Ez a szakasz módosul. A szövege az alábbi teljes változatban található.',
  diffHeading: 'Módosítások',
  outcomeArchived: 'Archiválva.',
  outcomeArchivedBody:
    'A(z) {title} oldal már nem befolyásolja a válaszokat, és lekerült az oldallistáról. A változatai, ez a javaslat és a döntés az oldal előzményeiben maradnak.',
  openArchivedPage: 'Archivált oldal megnyitása',
  outcomeApproved: 'Jóváhagyva.',
  outcomeApprovedRevision: 'A(z) {n}. változat mostantól a(z) {title} oldal jóváhagyott változata.',
  outcomeApprovedPlain: 'Ezt a javaslatot jóváhagyták.',
  outcomeRestored: 'Az oldal visszakerült az oldallistára, és ismét befolyásolja a válaszokat.',
  outcomeKept: 'A javaslat, a döntés és minden korábbi változat az oldal előzményeiben marad.',
  openPage: 'Oldal megnyitása',
  outcomeDismissed: 'Elvetve.',
  outcomeWithdrawn: 'Visszavonva.',
  outcomeSuperseded: 'Elavult.',
  outcomeSupersededBody:
    'Egy újabb változat, javaslat vagy tárolóimportálás elavulttá tette ezt a javaslatot. Önmagában semmit sem módosított.',
  outcomeUnchanged: 'Az oldal változatlan marad.',
  approveNewPage: 'Új oldal jóváhagyása',
  approveArchive: 'Archiválás jóváhagyása',
  approveRestoreRevision: 'Visszaállítás és a(z) {n}. változat jóváhagyása',
  approveRevision: 'A(z) {n}. változat jóváhagyása',
  approveArchiveNote: 'A jóváhagyással ez az oldal archiválódik {company} minden tagja számára.',
  approvePublishNote:
    'A jóváhagyással ez a változat közzétételre kerül {company} minden tagja számára.',
  approvePublishEvidenceNote:
    'A jóváhagyással ez a változat és a fent látható bizonyítékrészletek közzétételre kerülnek {company} minden tagja számára.',
  archivedTitle: 'Ez az oldal archiválva van.',
  alreadyArchivedBody: 'A jóváhagyás semmit sem változtatna, ezért ez a javaslat csak elvethető.',
  archivedRestoreBody:
    'A jóváhagyás visszaállítja: az oldal ezzel a változattal visszakerül az oldallistára, a keresésbe és a válaszokba.',
  staleRevisionAction: 'Összevetés a legújabb verzióval',
  staleProposalTitle: 'Ez a javaslat megváltozott, miközben Ön ellenőrizte.',
  staleProposalAction: 'A legújabb verzió ellenőrzése',
  staleArchivedTitle:
    'Ezt az oldalt archiválták, miközben Ön ellenőrizte. A javaslat jóváhagyása visszaállítaná.',
  staleArchivedAction: 'Újraellenőrzés',
  suggestionMissingTitle: 'Ez a javaslat nem érhető el.',
  suggestionMissingBody:
    'Lehet, hogy visszavonták, vagy valaki másé, és még nem küldték céges ellenőrzésre.',
  decideUnconfirmed:
    'Nem sikerült megerősíteni a döntését. A megjelenített állapot a Poneva legfrissebb adata; újrapróbálás előtt ellenőrizze.',
  decideFailed: 'Nem sikerült menteni a döntését.',
  discussPrompt: 'Segíts finomítani a(z) „{title}” oldalhoz javasolt tudásfrissítést ({link}).',
  conflictBody:
    'Ez a javaslat a(z) {base}. változat alapján készült; az aktuális változat: {current}. A jóváhagyása felülírná azt a módosítást, ezért jelenlegi formájában nem hagyható jóvá.',
  conflictBodyPlain:
    'Ez a javaslat egy korábbi változat alapján készült, ezért jelenlegi formájában nem hagyható jóvá.',
  openLatest: 'A legújabb verzió megnyitása',
  reworkInChat: 'Átdolgozás a csevegésben',
  factReason: 'Indoklás',
  factNoReason: 'Nincs megadva indoklás.',
  factAudience: 'Célközönség',
  factRevision: 'Változat',
  revisionNew: 'Új oldal, 1. változat',
  revisionArchiveAfter: 'Archiválás ezen változat után: {n}',
  revisionWrittenAgainst: 'A(z) {base}. változat alapján készült; az aktuális változat: {current}',
  revisionCurrentToProposed: 'Aktuális változat: {base} → javasolt változat: {next}',
  revisionProposed: 'Javasolt változat: {next}',
  proposedPage: 'Javasolt oldal',
  archivingHeading: 'Mit jelent az archiválás',
  archivingBody:
    'Az oldal többé nem befolyásolja a válaszokat, és lekerül az oldallistáról. A változatai és ez a döntés megmaradnak.',
  noComparison: 'Ehhez a javaslathoz nem érhető el szakaszösszevetés.',
  showComplete: 'Teljes változat megjelenítése',
  approving: 'Jóváhagyás…',
  dismissing: 'Elvetés…',
  dismiss: 'Elvetés',
  withdrawing: 'Visszavonás…',
  withdraw: 'Visszavonás',
  editInChat: 'Szerkesztés a csevegésben',
  waitingForPublisher: 'Arra vár, hogy a cég egyik közzétevője ellenőrizze.',
  snapshotTooLarge: 'Ez a pillanatkép nagyobb 8 MB-nál. Készítse el kevesebb dokumentummal.',
  snapshotNotSnapshot:
    'Ez a fájl nem tudás-pillanatkép. Válassza ki a pillanatkép-szkript által írt JSON-fájlt.',
  snapshotEmpty: 'Ez a pillanatkép nem tartalmaz dokumentumokat.',
  readDocumentFailed: 'Nem sikerült beolvasni ezt a dokumentumot. Próbálja újra.',
  readingDocument: 'Dokumentum beolvasása…',
  hideText: 'Szöveg elrejtése',
  readText: 'Szöveg olvasása',
  textOf: '{title} szövege',
  gitSnapshot: 'Git-pillanatkép: {commit}',
  repositorySnapshot: 'Tárolópillanatkép',
  importNewHeading: '{pages} · alkalmazáskor jóváhagyva',
  importNewNote:
    'Mindegyik jóváhagyott oldalként jelenik meg {company} minden tagja számára, további ellenőrzés nélkül. Alkalmazás előtt olvassa el mindegyiket.',
  importChangedHeading: '{pages} · ellenőrzésre küldve',
  importChangedNote:
    'Mindegyikből javasolt frissítés lesz. Az oldala csak akkor változik, ha egy közzétevő jóváhagyja az Ellenőrzésre vár lapon, amely megmutatja, mi változott.',
  unchangedDocumentCount: 'one:változatlan dokumentum|other:változatlan dokumentum',
  unchangedNote: 'Ezek már megegyeznek a jóváhagyott oldalaikkal. Semmi sem íródik hozzájuk.',
  stagedHeading: 'Előkészítve, de nincs alkalmazva',
  excludedSummary: '{documents} kimaradt ebből a pillanatképből',
  countsLine: '{newPages} · {changedPages} ellenőrzésre · {unchanged} változatlan',
  importAlreadyDiscarded: 'Ezt az importálást már elvetették.',
  confirmLabel: 'Importálás megerősítése',
  unchangedKeepCount:
    'one:változatlan dokumentum megtartja az oldalát|other:változatlan dokumentum megtartja az oldalát',
  confirmBody:
    'Alkalmazza ezt az importálást {company} minden tagja számára? {newPages} 1. változatként lesz jóváhagyva, {changedPages} ellenőrzésre vár, és {unchanged}. Az ezekhez az oldalakhoz tartozó korábbi importálási javaslatok visszavonásra kerülnek.',
  applying: 'Alkalmazás…',
  applyImport: 'Importálás alkalmazása',
  chooseAnother: 'Másik fájl kiválasztása',
  allCurrent: 'Ebben a pillanatképben minden naprakész.',
  importApplied: 'Az importálás alkalmazva.',
  appliedSummary: '{pages} létrehozva · {changes} ellenőrzésre vár · {unchanged} változatlan.',
  appliedIndexing:
    'Az új oldalak az indexelés befejezése után válnak kereshetővé a csevegésben. A forrás-előkészítés mutatja az előrehaladást.',
  openPages: 'Oldalak megnyitása',
  reviewChanges: '{changes} ellenőrzése',
  checkIndexing: 'Indexelés állapotának ellenőrzése',
  sendSnapshotFailed: 'Nem sikerült elküldeni ezt a pillanatképet. Próbálja újra.',
  openStagedFailed: 'Nem sikerült megnyitni ezt az előkészített importálást.',
  applyUnconfirmed:
    'Nem sikerült megerősíteni, hogy az importálás megtörtént-e. Újrapróbálás előtt ellenőrizze az Oldalak lapot.',
  applyFailed: 'Nem sikerült alkalmazni ezt az importálást.',
  importHeading: 'Oldalak importálása a tárolóból',
  backToPages: 'Vissza az oldalakhoz',
  importLead:
    'Készítsen pillanatképet a(z) {command} paranccsal, majd válassza ki a fájlt. Mentés előtt minden dokumentumot látni fog, és azt is, hogy mit módosítana.',
  snapshotFileLabel: 'Tudás-pillanatképfájl',
  readingSnapshot: 'Pillanatkép beolvasása…',
  openingStaged: 'Előkészített importálás megnyitása…',
  chooseSnapshot: 'Pillanatképfájl kiválasztása',
  factOrigin: 'Eredet',
  factContents: 'Tartalom',
  importOnlyListed: 'Csak az itt felsorolt dokumentumok kerülnek importálásra.',
  importRepositoryAuthoritative:
    'A tároló marad a mérvadó; a módosult dokumentumokból ellenőrzendő javaslatok lesznek.',
  overviewReviewChanges: 'Módosítások ellenőrzése',
  overviewConnectAgents: 'Külső ügynökök csatlakoztatása',
  overviewEyebrow: 'Közös megértés',
  overviewTitle: '{company} – kontextusban.',
  overviewLeadFallback:
    'A cége tudása az Ön által megosztott kontextussal kezdődik. Építse fel közösen a vállalkozása megértését.',
  overviewBody:
    'A céges kontextus és a forrásanyagok kiindulópontot adnak a Poneva számára – nem mindent, amit {company} működéséről tudni lehet. Építse tovább ezt a tudást, ahogy a vállalkozása fejlődik.',
  overviewAskPrompt: 'Mit tudsz a cégünkről, és mit lenne hasznos hozzáadni?',
  overviewAsk: 'Kérdés erről: {company}',
  overviewAddSources: 'Források hozzáadása',
  contextEyebrow: 'Mi ad kontextust a válaszoknak',
  contextTitle: 'Az üzlet a kérdés mögött.',
  contextBody:
    'A webhelyforrások a nyilvános üzleti működést mutatják be. A céges jegyzetek az Ön szakszavait, prioritásait és munkamódját teszik hozzá.',
  contextPrompt:
    'Segíts tisztázni a cég prioritásait és munkavégzési preferenciáit, amelyeket érdemes megjegyeznünk.',
  contextAction: 'Közös tudásunk építése',
  learnEyebrow: 'Tér a tanulásra',
  learnTitle: 'Kezdje azzal, ami a következő lépésben fontos.',
  learnBody:
    'Hozzon be forrásanyagot, vagy tisztázza, hogyan működik a cége. A Poneva tartós módosításokat javasolhat, amelyeket Ön ellenőriz.',
  learnPrompt:
    'A meglévő céges tudásunk alapján milyen fontos információk hiányoznak az elvégezni kívánt munkához?',
  learnAction: 'Beszéljük meg, mi lenne hasznos',
  canvasEmptyTitle: 'Kevés kontextus is sokat számít.',
  canvasEmptyBody:
    'A cégprofil a kiindulópont. Adjon hozzá forrásanyagot és ellenőrzött jegyzeteket, hogy a Poneva jobban megértse a munkáját.',
  pageEyebrow: '{company} munkaterülete',
  pageTitle: 'Céges tudás',
  pageDescription: 'A Poneva munkáját megalapozó források és ismeretek.',
  tabOverview: 'Áttekintés',
  tabPages: 'Oldalak',
  tabSources: 'Források',
  tabReview: 'Ellenőrzésre vár',
  proposalApproved: 'Jóváhagyott céges kontextus',
  proposalDismissed: 'Elvetett javaslat',
  proposalRemoval: 'Javasolt eltávolítás',
  proposalCorrection: 'Javasolt javítás',
  proposalContext: 'Javasolt céges kontextus',
  proposalCurrent: 'Jelenlegi ismeretek',
  proposalFactGone:
    'A mentett tény már nem érhető el. Az eltávolítás ellenőrzése előtt frissítse a céges tudást.',
  proposalReviewFallback: 'Ellenőrizze a javasolt céges kontextust.',
  proposalNotSaved: 'Még nincs mentve. Az eredeti források változatlanok maradnak.',
  proposalWaiting:
    'Ellenőrzésre vár · a cég egyik közzétevője dönt róla a Beérkezett elemek nézetben',
  proposalSaving: 'Mentés…',
  proposalApproveRemoval: 'Eltávolítás jóváhagyása',
  proposalApproveClarification: 'Pontosítás jóváhagyása',
  factLabel: 'Céges tény',
  factEyebrow: 'Tény · {company} minden tagja',
  factSuggestCorrection: 'Javítás javaslása',
  factAskPrompt: 'Segíts megérteni vagy pontosítani ezt a mentett céges kontextust: „{content}”',
  factAsk: 'Kérdés róla',
  companyContextHeading: 'Céges kontextus',
  companyContextPrompt:
    'Szeretném pontosítani a cégünkről szóló tudást. Segíts áttekinteni, mit tudunk, és javasolj frissítést.',
  companyContextEmpty:
    'Még nincsenek jóváhagyott jegyzetek. Kezdjen beszélgetést a cégéről, vagy adjon hozzá forrásanyagot alább.',
  refineInChat: 'Finomítás a csevegésben',
  reviewPanelLabel: 'Ellenőrzésre váró tudásmódosítások',
  suggestedUpdatesHeading: 'Javasolt frissítések',
  suggestedUpdatesIntro:
    'Javaslatok a beszélgetéseiből. Ön dönti el, mi válik a cége tartós tudásának részévé.',
  reviewEmptyTitle: 'Semmi sem vár az Ön ellenőrzésére.',
  reviewEmptyBody:
    'Ha a Poneva módosítást javasol a céges tudásban, itt találja. A tartós módosításokhoz mindig az Ön jóváhagyása szükséges.',
  reviewEmptyPrompt:
    'Segíts átnézni a céges tudásunkat, és javasold, mit lenne hasznos legközelebb pontosítani.',
  inclusionPendingApproval: 'A tudásba való felvétel módosítása jóváhagyásra elküldve.',
  sourcesFileIncluded: 'A fájl bekerült a tudáskeresésbe a jelenlegi célközönsége számára.',
  sourcesAddFailed: 'Nem sikerült hozzáadni ezt a forrást.',
  sourcesHeading: 'A válaszok mögötti anyag.',
  sourcesIntro:
    'A Poneva a teljes forrásanyagban keres, nem csak az áttekintésben. Őrizze meg az eredetieket, nézze meg, mi áll készen, és válassza ki, mi alapozza meg a válaszait.',
  addSourceHeading: 'Anyag hozzáadása a cégétől',
  addSourceIntro:
    'A feltöltött források privátak maradnak a Könyvtárában, és csak az Ön válaszait alapozzák meg. Válassza a Megosztás lehetőséget, ha elérhetővé szeretné tenni őket a kollégái számára.',
  uploadSource: 'Forrás feltöltése',
  addSourcePrompt:
    'Segíts hozzáadni egy céges nyilatkozatot közös belső forrásként. Kérdezd meg, mit szeretnék rögzíteni; ne találj ki semmilyen tartalmat. A céges ismeretek tartós módosításaihoz továbbra is az én jóváhagyásom szükséges.',
  addThroughChat: 'Hozzáadás csevegésben',
  addingSource: 'Hozzáadás…',
  addToKnowledge: 'Hozzáadás a tudáshoz',
  uploadFormats: 'TXT, Markdown, CSV és JSON · Fájlonként legfeljebb 5 MB',
  sourceExcluded: 'Kizárva a válaszokból',
  sourcePreparationFailed: 'Sikertelen előkészítés',
  sourcePreparing: 'Előkészítés kereséshez',
  sourceWaiting: 'Előkészítésre vár',
  sourceReadinessUnknown: 'A készenlét nem ismert',
  sourceRetryQueued: 'Az előkészítés sorba került. A készenléti állapot a befejezés után frissül.',
  sourceIncludedNotice: 'Forrás felvéve. A Poneva előkészíti a kereséshez.',
  sourceExcludedNotice: 'Kizárva a válaszokból. Az eredeti forrás megmarad.',
  sourceUpdateFailed: 'Nem sikerült frissíteni ezt a forrást.',
  sourceOriginalMaterial: 'Eredeti forrásanyag',
  sourceDiscuss: 'Megbeszélés a csevegésben',
  sourceDiscussPrompt: 'Segíts megérteni vagy pontosítani ezt: „{title}”.',
  sourceExclude: 'Kizárás a válaszokból',
  sourceInclude: 'Felvétel a válaszokba',
  sourcesLoadFailed: 'Nem sikerült betölteni a forrásait.',
  sourceLibraryLabel: 'Céges forráskönyvtár',
  sourceListCaption: 'Eredeti források · felvett és kizárt',
  sourceSearchLabel: 'Keresés a céges forrásokban',
  sourceSearchPlaceholder: 'Keresés a forrásaiban…',
  sourcesFinding: 'Források keresése…',
  sourcePagesLabel: 'Források lapozása',
  sourceRange: '{count} közül {from}–{to}',
  sourceCount: 'one:forrás|other:forrás',
  sourcePrevious: 'Előző',
  sourceNext: 'Következő',
  sourceNoMatchTitle: 'Nincs egyező forrás.',
  sourceNoMatchBody: 'Próbálkozzon másik kifejezéssel vagy forrásnévvel.',
  sourceEmptyTitle: 'Adjon erősebb kiindulópontot a kérdéseinek.',
  sourceEmptyBody:
    'Adjon hozzá céges dokumentumokat, termékadatokat vagy munkajegyzeteket. A Poneva a teljes forrásanyagot felhasználhatja a beszélgetésekben és a Skillekben.',
  indexCheckFailed: 'Nem sikerült ellenőrizni a források előkészítését.',
  indexRetryQueued:
    'A sikertelen tudásbejegyzések előkészítésre sorba kerültek. A forrásanyag változatlan.',
  indexQueueFailed: 'Nem sikerült sorba állítani az előkészítést. Próbálja újra.',
  indexPreparing: 'Új tudás előkészítése a beszélgetéseihez…',
  indexAttention: 'A tudás egy része beavatkozást igényel.',
  queuing: 'Sorba állítás…',
  retryPreparation: 'Előkészítés újrapróbálása',
  sourceKindStatement: 'Céges nyilatkozat',
  sourceKindWebsite: 'Webhely',
  sourceKindDocument: 'Dokumentum',
  factAnswers: 'one:válasz|other:válasz',
  factUsedThisWeek: 'Felhasználva ezen a héten: {answers}',
  factLastUsed: 'utoljára használva: {when}',
  factToday: 'ma',
  factYesterday: 'tegnap',
  factImpact: 'A módosítás egy ezen a héten felhasznált tényt érint ({answers}).',
  factCorrectionAbout: 'Erről a céges tényről: „{content}” ({link})',
  factCorrectionOutdated: 'Ez már elavult:',
  sourceCanvasRecorded: 'Rögzített forrásanyag',
  sourceCanvasNotIncluded:
    'Nem része a céges tudásnak. Az eredetit referenciaként megőrizzük, és egy adott beszélgetésben továbbra is használható.',
  sourceCanvasOpenOriginal: 'Eredeti forrás megnyitása',
  sourceCanvasUnavailable: 'A forrás tartalma nem érhető el.',
  sourceCanvasDiscussPrompt: 'Segíts megérteni vagy pontosítani ezt: „{title}”.',
  sourceCanvasDiscuss: 'A forrás megvitatása',
  sourceCanvasCorrectionNote:
    'A javításból javasolt céges kontextus lesz. A rögzített forrás változatlan marad.',
  contextCanvasEyebrow: 'Elérhető céges kontextus',
  contextCanvasTitle: 'A beszélgetés mögötti tudás.',
  contextCanvasBody:
    'Jóváhagyott ismeretek és a cége által hozzáadott forrásanyag. Elérhető a csevegésben és a Skills funkcióban.',
  contextCanvasOpen: 'Tudás megnyitása',
};

export default hu;
